import React from "react"
import { Field, reduxForm, Form } from "redux-form"
import PropTypes from "prop-types"
import { compose } from "recompose"
import { connect } from "react-redux"
import { Button, Icon } from "antd"
import styled from "styled-components"
import { FormattedMessage } from "react-intl"
import Text from "../text"
import Box from "../../lib/ui/ui-box"
import { Media } from "../../lib/theme"
import Validators from "../../lib/validators"
import { defaultValues } from "./options"
import renderTextfield from "../render-textfield"
import renderRadioGroup from "../render-radio-group"

const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  ${Media.medium`
    flex-direction: row;   
    align-items: flex-end;
  `};
`

const Step = props => {
  return (
    <StyledForm onSubmit={props.handleSubmit}>
      <Box flexDirection="column" w={["90%", "90%", "552px"]}>
        <Box flexDirection="column">
          {/* Category */}
          <Text
            fontFamily="Libre Baskerville"
            fontSize={[1, 1]}
            lineHeight={[3, 4]}
            fontWeight="400"
            color="#A8A7A9"
          >
            <FormattedMessage id="renewal.step_5.category" />
          </Text>
          {/* Title */}
          <Text
            fontFamily="Libre Baskerville"
            fontSize={[3, 4]}
            lineHeight={[3, 4]}
            fontWeight="700"
            color="#2B3E51"
          >
            <FormattedMessage id="renewal.step_5.title" />
          </Text>
        </Box>
        {/* Radio Group */}
        <Box mt={[3]} flexDirection="column">
          <Field
            name="consulted"
            choices={[
              {
                label: props.intl.formatMessage({
                  id: "newMortgage.step_5.consultedAlreadyYes"
                }),
                value: "yes"
              },
              {
                label: props.intl.formatMessage({
                  id: "newMortgage.step_5.consultedAlreadyNo"
                }),
                value: "no"
              }
            ]}
            validate={[Validators.isRequired]}
            component={renderRadioGroup}
          />
        </Box>
        {/* Types */}
        {
          props.stepFiveData.hasConsulted === "yes" ? (
            <Box
              my={[2]}
              pt={[3]}
              flexDirection="column"
              style={{ borderTop: "1px solid #CBCBCB" }}
            >
              <Field
                name="consultedType"
                choices={[
                  {
                    label: props.intl.formatMessage({
                      id: "newMortgage.step_5.consultedType1"
                    }),
                    value: "Other Reverse Mortgage Lender"
                  },
                  {
                    label: props.intl.formatMessage({
                      id: "newMortgage.step_5.consultedType2"
                    }),
                    value: "Family"
                  },
                  {
                    label: props.intl.formatMessage({
                      id: "newMortgage.step_5.consultedType3"
                    }),
                    value: "Wealth Manager"
                  },
                  {
                    label: props.intl.formatMessage({
                      id: "newMortgage.step_5.consultedType4"
                    }),
                    value: "Bank Branch"
                  },
                  {
                    label: props.intl.formatMessage({
                      id: "newMortgage.step_5.consultedType5"
                    }),
                    value: "Broker"
                  },
                  {
                    label: props.intl.formatMessage({
                      id: "newMortgage.step_5.consultedType6"
                    }),
                    value: "Other"
                  }
                ]}
                validate={[Validators.isRequired]}
                component={renderRadioGroup}
              />
            </Box>
          ) : null
        }
        {/* Other Field */}
        <Box>
          {
            props.stepFiveData.hasConsulted === "yes" && props.stepFiveData.hasConsultedType === "Other" ? (
              <Field
                name="consultedTypeOther"
                placeholder={props.intl.formatMessage({
                  id: "newMortgage.step_5.placeholder_consultedTypeOther"
                })}
                component={renderTextfield}
                validate={[Validators.isRequired]}
              />
            ) : null
          }
        </Box>
        {/* Submit Button */}
        <Box mt={[3]}>
          <Button.Group size="large">
            <Button
              // disabled={props.invalid || props.isFlowInvalid}
              type="primary"
              htmlType="submit"
            >
              <FormattedMessage id="renewal.step_5.cta" />
              <Icon type="right" />
            </Button>
          </Button.Group>
        </Box>
      </Box>
    </StyledForm >
  )
}

Step.propTypes = {
  isFlowInvalid: PropTypes.bool.isRequired
}

export default compose(
  connect(state => ({
    initialValues: defaultValues
  })),
  reduxForm({
    form: "renewalMortgageWizard",
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })
)(Step)



// WEBPACK FOOTER //
// ./src/components/renewal-wizard/step-five.component.js